import { FeedbackFormFields } from "@features/FeedBackForm/view/FeedBackForm.typedef";
import { phoneNumberNormalizer } from "@shared/functions/phoneNumberNormalizer/phoneNumberNormalizer";
import { ContactFormDTO } from "@generated/models/ContactFormDTO";

export const mapFeedbackForm = (fields: FeedbackFormFields): ContactFormDTO => {
	const formattedPhone = phoneNumberNormalizer(fields.phone);

	return {
		...fields,
		phone: formattedPhone,
		name: fields.name.trim(),
		email: fields.email.trim(),
		question: fields.question.trim(),
	};
};
